import React from "react";
import { getTagContent } from "../utils";

type Props = { url: string; placeholderString: string; tag: string };

/**
 * Parses a 'text with [tag]url[/tag]' placeholderString into a React component.
 */
const PlaceholderUrl = ({ url, placeholderString, tag }: Props): JSX.Element => {
    const linkContent = getTagContent(tag, placeholderString);
    const leftLabel = linkContent
        ? placeholderString.substring(0, placeholderString.indexOf(`[${tag}]`))
        : placeholderString;
    const rightLabel = linkContent ? placeholderString.substring(placeholderString.indexOf(`[/${tag}]`) + 7) : "";

    return (
        <>
            {leftLabel || ""}
            {!!linkContent && (
                <a href={url} target="_blank" rel="noreferrer">
                    {linkContent}
                </a>
            )}
            {rightLabel || ""}
        </>
    );
};

export default PlaceholderUrl;
